// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GlobalPopup_wrapper__2Wth9","wrapperInner":"GlobalPopup_wrapperInner__1ybQ-","boxClose":"GlobalPopup_boxClose__y5W01"};